// External deps
import { useState, useEffect } from 'react';
import { Loader, Button } from 'ypf-pas-general-ui-components';
import { AiOutlineDownload } from 'react-icons/ai';

// Internal deps
import HeaderTitle from '../../components/NotificationReport/TemporalComponents/HeaderTitle/HeaderTitle';
import NotificationReportHeader from '../../components/NotificationReport/NotificationReportHeader/NotificationReportHeader';
import NotificationReportTable from '../../components/NotificationReport/NotificationReportTable/NotificationReportTable';
import NotificationReportAnexo from '../../components/NotificationReport/NotificationReportAnexo/NotificationReportAnexo';
import NotFoundData from '../../components/NotFoundData/NotFoundData';
import useLocalStorage from '../../hooks/useLocalStorage';
import { postExcelDetail, postReporteNotificacion } from '../../services/notificationReport';
import { checkRol } from '../../security';
import { inspector } from '../../security/constantsRols';
import useToast from '../../hooks/useToast';

const NotificationReport = () => {
  const [isReady, setIsReady] = useState(false);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { getLocalStorageItem } = useLocalStorage();
  const { setNewToast } = useToast();
  const queryNRContractNumber = getLocalStorageItem('nr_cn');
  const queryNRWell = getLocalStorageItem('nr_wl');
  const queryNRDateFrom = getLocalStorageItem('nr_df');
  const queryNRDateTo = getLocalStorageItem('nr_dt');

  const fetchDataNR = async (body) => {
    setLoading(true);

    try {
      const res = await postReporteNotificacion(body);

      setData(res);
      if (res?.reporteDeCostos?.contrato === 0) {
        setNewToast({
          type: 'ERROR',
          message: 'No se encontró ninguna coincidencia'
        });
      }

      setIsReady(true);
      setLoading(false);
    } catch (err) {
      setIsReady(false);
      setLoading(false);
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const downloadReport = async () => {
    try {
      setNewToast({
        type: 'INFO',
        message: 'Sus archivos se están descargando. Por favor, no actualice la página.'
      });
      const body = {
        contrato: queryNRContractNumber,
        nombreLegal: queryNRWell,
        fechaDesde: `${queryNRDateFrom}T00:00:00.000Z`,
        fechaHasta: `${queryNRDateTo}T00:00:00.000Z`
      };

      await postExcelDetail(body);

      setNewToast({
        type: 'SUCCESS',
        message: 'Sus archivos han sido descargados!'
      });
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  useEffect(() => {
    if (
      queryNRContractNumber &&
      queryNRWell &&
      queryNRDateFrom &&
      queryNRDateTo &&
      checkRol(inspector)
    ) {
      const NRDateFrom = `${queryNRDateFrom}T00:00:00.000Z`;
      const NRDateTo = `${queryNRDateTo}T00:00:00.000Z`;
      const NRWell = decodeURI(queryNRWell);

      fetchDataNR({
        contrato: queryNRContractNumber,
        nombreLegal: NRWell,
        fechaDesde: NRDateFrom,
        fechaHasta: NRDateTo
      });
    } else {
      setNewToast({
        type: 'ERROR',
        message: 'No posee permisos para realizar esta acción'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return !isReady || !checkRol(inspector) || data?.reporteDeCostos?.contrato === 0 ? (
    <div className="pas-container fluid-75">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: '20px'
        }}
      >
        <HeaderTitle arrowLeft={false} title="Reporte notificación Y-Click" />
      </div>
      <NotFoundData />

      <Loader show={loading} text="CARGANDO" />
    </div>
  ) : (
    <div className="pas-container fluid-75">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: '20px'
        }}
      >
        <HeaderTitle arrowLeft={false} title="Reporte notificación Y-Click" />
        <Button
          icon={AiOutlineDownload}
          iconRight
          label="Exportar detalle Excel"
          onClick={downloadReport}
          sizeIcon="20px"
          type="button"
          variant="outline-primary"
          widthButton="200px"
        />
      </div>

      <NotificationReportHeader
        // data={mockData.reporteDeCostos}
        data={data.reporteDeCostos}
      />
      <NotificationReportTable
        data={data.reporteDeCostos}
        // data={mockData.reporteDeCostos}
      />
      <NotificationReportAnexo data={data} />
    </div>
  );
};

export default NotificationReport;
